import {inject, Injectable} from '@angular/core';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';

@Injectable({ providedIn: 'root' })
export class AuthReadyService {

  private readyPromise: Promise<void>;
  private auth = inject(Auth);
  constructor() {
    this.readyPromise = new Promise(resolve => {
      onAuthStateChanged(this.auth, () => {
        resolve();
      });
    });
  }

  waitUntilReady(): Promise<void> {
    return this.readyPromise;
  }
}
